import { combineReducers } from 'redux';
import authReducer from './authReducer';
import tableStateReducer from './tableStateReducer';

export default combineReducers({
    auth: authReducer,
    tableState: tableStateReducer
});
